// Para poder mockar nos testes
export const location = {
  // eslint-disable-next-line @typescript-eslint/no-misused-spread
  ...window.location,
  assign(url: string) {
    window.location.assign(url);
  },
  replace(url: string) {
    window.location.replace(url);
  },
};

/**
 * Manda o navegador para uma url de fora do router (a tela do Autenticador, o site
 * antigo) e fica aguardando a saída da página. A promise não resolve, quem encerra a
 * espera é o navegador ao descarregar a página.
 *
 * Essa espera impede o React de renderizar a tela atual enquanto o navegador ainda
 * está saindo dela.
 */
export async function navegarEAguardarSaida(
  url: string,
  { replace = false } = {},
) {
  if (replace) {
    location.replace(url);
  } else {
    location.assign(url);
  }

  await new Promise(() => {
    // Promise infinita para aguardar o redirecionamento.
  });
}
